import { render, staticRenderFns } from "./returning_patient.vue?vue&type=template&id=3a7c1300&scoped=true&"
import script from "./returning_patient.vue?vue&type=script&lang=js&"
export * from "./returning_patient.vue?vue&type=script&lang=js&"
import style0 from "./returning_patient.vue?vue&type=style&index=0&id=3a7c1300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c1300",
  null
  
)

export default component.exports